import { Box, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { RoleIdText, StyledTab } from "./Atom"
import AddIcon from "@mui/icons-material/Add"
import ArrowRightIcon from "@mui/icons-material/ArrowRight"
import CloseIcon from "@mui/icons-material/Close"
import AddNewGroupDetail from "../../../Modal/AddGroupDetails"
import DeleteGroupDetail from "../../../Modal/DeleteGroupDetailsModal"
import { permissions } from "../../../../../config/constants"

function Groups(props: any) {
  const { fetchUserDetails } = props
  const allPerms = useSelector((state: any) => {
    return state.rolesAndPerms.userPerms
  })
  const userProfileData = useSelector(
    (state: any) => state.user?.userProfileData,
  )

  const [openGroupModal, setOpenGroupModal] = useState(false)
  const [openOfficeModal, setOpenOfficeModal] = useState(false)
  const [openDeleteConfirmationModal, setOpenDeleteConfirmationModal] =
    useState(false)
  const [deleteConfirmationData, setDeleteConfirmationData] = useState<any>({
    name: "",
    uid: "",
    group_sk: [],
    practice_sk: [],
  })
  const [basicDetails, setBasicDetails] = useState<any>({})
  const [assignedPractices, setAssignedPractices] = useState<any>([])

  const [groups, setGroups] = useState<Array<any>>([])

  useEffect(() => {
    setGroups(userProfileData?.assigned_groups)
    setBasicDetails(userProfileData?.basic_details)
    setAssignedPractices(userProfileData?.assigned_practices)
  }, [userProfileData])

  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      {allPerms.includes(permissions?.UPDATE_USER) && (
        // userProfileData?.basic_details?.status !== "invited" &&
        <Box
          sx={{
            width: "30%",
            height: "fit-content",
            border: "1px solid #E3E3E3",
            borderRight: "none",
          }}
        >
          {((basicDetails?.role_category === "office_manager" &&
            assignedPractices?.length === 0) ||
            (basicDetails?.role_category === "group_admin" &&
              userProfileData?.assigned_groups?.length === 0) ||
            (basicDetails?.role_category !== "office_manager" &&
              basicDetails?.role_category !== "group_admin")) && (
            <li
              style={{
                listStyle: "none",
                padding: "22px 20px",
                fontSize: "14px",
                color: "#3D76EF",
                display: "flex",
                fontWeight: "bold",
                textTransform: "capitalize",
                border: "1px solid #E5E5E5",
                cursor: "pointer",
              }}
              onClick={() => setOpenGroupModal(true)}
            >
              <AddIcon fontSize="small" />
              Assign{" "}
              {basicDetails?.role_category === "office_manager"
                ? "Offices"
                : "Groups"}
            </li>
          )}
          {groups?.length > 0 ? (
            groups?.map((group: any, groupIndex: any) => {
              return (
                <Box
                  key={groupIndex}
                  sx={{
                    backgroundColor:
                      basicDetails?.role_category === "office_manager"
                        ? "#4A79E7"
                        : "",
                    color:
                      basicDetails?.role_category === "office_manager"
                        ? "#fff"
                        : "",
                    cursor: "pointer",
                    border: "1px solid #E3E3E3",
                  }}
                >
                  <li
                    style={{
                      listStyle: "none",
                      padding: "22px 20px",
                      fontSize: "14px",
                      display: "flex",
                      justifyContent: "space-between",
                      fontWeight: "bold",
                      textTransform: "capitalize",
                      border: "1px solid #E5E5E5 ",
                      borderTop: "none",
                    }}
                  >
                    {group.group_name}
                    <p>
                      {basicDetails?.role_category === "office_manager" ? (
                        <ArrowRightIcon />
                      ) : (
                        <CloseIcon
                          onClick={() => {
                            setDeleteConfirmationData({
                              name: group.group_name,
                              uid: basicDetails?.uid,
                              group_sk: [group.group_sk],
                              practice_sk: [],
                            })
                            setOpenDeleteConfirmationModal(true)
                          }}
                        />
                      )}
                    </p>
                  </li>
                </Box>
              )
            })
          ) : (
            <Typography
              sx={{
                padding: "22px 20px",
                border: "1px solid #E5E5E5 !important",
              }}
            >
              No Group assigned
            </Typography>
          )}
        </Box>
      )}
      {basicDetails?.role_category === "office_manager" &&
        assignedPractices?.length && (
          <Box
            sx={{
              width: "30%",
              height: "fit-content",
              border: "1px solid #E3E3E3",
            }}
          >
            <li
              style={{
                listStyle: "none",
                padding: "22px 20px",
                fontSize: "14px",
                color: "#3D76EF",
                display: "flex",
                fontWeight: "bold",
                textTransform: "capitalize",
                borderTop: "1px solid #E5E5E5",
                borderBottom: "1px solid #E5E5E5",
                cursor: "pointer",
              }}
              onClick={() => setOpenOfficeModal(true)}
            >
              <AddIcon fontSize="small" />
              Assign Offices
            </li>

            {groups?.length &&
              assignedPractices?.map((office: any, officeIndex: any) => {
                return (
                  <li
                    key={officeIndex}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      listStyle: "none",
                      padding: "22px 20px",
                      fontSize: "14px",
                      color: "#000",
                      fontWeight: "bold",
                      borderBottom: "1px solid #E5E5E5",
                    }}
                  >
                    <span>
                      {office.name}
                      <RoleIdText>{office.region}</RoleIdText>
                    </span>
                    <CloseIcon
                      sx={{
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setDeleteConfirmationData({
                          name: office.name,
                          uid: basicDetails?.uid,
                          group_sk: [groups[0]?.group_sk],
                          practice_sk: [office.practice_sk],
                        })
                        setOpenDeleteConfirmationModal(true)
                      }}
                    />
                  </li>
                )
              })}
          </Box>
        )}
      <DeleteGroupDetail
        open={openDeleteConfirmationModal}
        setOpen={setOpenDeleteConfirmationModal}
        data={deleteConfirmationData}
        setData={setDeleteConfirmationData}
        fetchUserDetails={fetchUserDetails}
      />
      <AddNewGroupDetail
        open={openGroupModal || openOfficeModal}
        setOpen={openGroupModal ? setOpenGroupModal : setOpenOfficeModal}
        isNewOffice={openOfficeModal}
        groupSk={groups?.length > 0 && groups[0]?.group_sk}
        fetchUserDetails={fetchUserDetails}
        uid={basicDetails?.uid}
        multiple={basicDetails?.role_category !== "group_admin"}
        isNewOfficeManagerGroup={
          basicDetails?.role_category === "office_manager" &&
          groups.length === 0
        }
      />
    </Box>
  )
}

export default Groups
